import { FC } from 'react'

import styled from 'styled-components'
import { RadioProps } from 'antd'
import { useSelector } from 'react-redux'

import ApplePayIcon from 'src/Assets/Svg/payment-systems/applePay.svg?react'
import GooglePayIcon from 'src/Assets/Svg/payment-systems/googlePay.svg?react'
import { PaymentMethodEnum, WalletPaymentMethod } from 'src/Constants/enums'
import { PrimaryRadio } from 'src/Components/PrimaryRadio'
import { getResolvedTheme } from 'src/Redux/theme-process'

const APPLE_PAY_LOGO_WIDTH = 47
const GOOGLE_PAY_LOGO_WIDTH = 50
const GOOGLE_PAY_TEXT_FILL = '#60646A'

const LogoWrapper = styled.div<{
  $width: number
  $isMonochrome?: boolean
  $hasLightText?: boolean
}>`
  display: flex;
  height: 32px;
  align-items: center;

  svg {
    display: block;
    width: ${({ $width }) => `${$width}px`};
    height: auto;
  }

  ${({ $isMonochrome, theme }) =>
    $isMonochrome
      ? `
    svg path {
      fill: ${theme.color.darkGrey};
    }
  `
      : ''}

  ${({ $hasLightText, theme }) =>
    $hasLightText
      ? `
    svg path[fill='${GOOGLE_PAY_TEXT_FILL}'] {
      fill: ${theme.unchangingColor.white};
    }
  `
      : ''}
`

interface Props extends RadioProps {
  value: WalletPaymentMethod
}

export const WalletRadioButton: FC<Props> = ({ value, ...restProps }) => {
  const resolvedTheme = useSelector(getResolvedTheme)
  const isApplePay = value === PaymentMethodEnum.APPLE_PAY
  const isDarkTheme = resolvedTheme === 'dark'

  return (
    <PrimaryRadio {...restProps} value={value}>
      <LogoWrapper
        $width={isApplePay ? APPLE_PAY_LOGO_WIDTH : GOOGLE_PAY_LOGO_WIDTH}
        $isMonochrome={isApplePay}
        $hasLightText={!isApplePay && isDarkTheme}
      >
        {isApplePay ? <ApplePayIcon /> : <GooglePayIcon />}
      </LogoWrapper>
    </PrimaryRadio>
  )
}
